import * as React from 'react';
import styled from '@emotion/styled';

interface PropsType {
    className?: string;
    fill?: string;
}

const SvgElement = styled('svg', { label: 'SvgElement' })<PropsType>`
    height: auto;
`;

export const VisaCard = ({ className }: PropsType): JSX.Element => (
    <SvgElement
        className={className}
        width={32}
        height={20}
        viewBox='0 0 32 20'
        fill='none'
    >
        <path
            d='M0 2C0 0.895431 0.895431 0 2 0H30C31.1046 0 32 0.895431 32 2V18C32 19.1046 31.1046 20 30 20H2C0.895431 20 0 19.1046 0 18V2Z'
            fill='white'
        />
        <path
            d='M2 0.5H30C30.8284 0.5 31.5 1.17157 31.5 2V18C31.5 18.8284 30.8284 19.5 30 19.5H2C1.17157 19.5 0.5 18.8284 0.5 18V2C0.5 1.17157 1.17157 0.5 2 0.5Z'
            stroke='#101D3A'
            strokeOpacity='0.1'
        />
        <path
            d='M15.9027 6.8846L14.5665 13.1314H12.9503L14.2867 6.8846H15.9027ZM22.7019 10.9183L23.5525 8.57244L24.042 10.9183H22.7019ZM24.5056 13.1314H26L24.6945 6.8846H23.316C23.0053 6.8846 22.7435 7.06472 22.6275 7.34249L20.2026 13.1314H21.8999L22.2368 12.1985H24.3099L24.5056 13.1314ZM20.2868 11.0921C20.2938 9.44341 18.0077 9.35209 18.023 8.61544C18.0279 8.39162 18.2415 8.15319 18.7082 8.09221C18.9396 8.06242 19.5782 8.03825 20.3021 8.37181L20.5852 7.04659C20.1964 6.90595 19.6961 6.77051 19.0735 6.77051C17.4759 6.77051 16.352 7.61914 16.343 8.83532C16.3328 9.73467 17.1459 10.2361 17.7572 10.5357C18.3875 10.8418 18.5987 11.0381 18.5956 11.3117C18.5912 11.7308 18.093 11.9164 17.629 11.9234C16.8161 11.9361 16.3449 11.7037 15.9693 11.5286L15.6759 12.8981C16.0542 13.0712 16.7511 13.2218 17.4727 13.2295C19.1712 13.2295 20.2817 12.3909 20.2868 11.0921ZM13.5934 6.8846L10.9749 13.1314H9.26681L7.97812 8.14602C7.90001 7.83945 7.83186 7.72676 7.59427 7.59722C7.20565 7.38619 6.56411 7.18878 6 7.06598L6.03822 6.8846H8.78812C9.13839 6.8846 9.45353 7.11769 9.53376 7.52121L10.2145 11.1363L11.8956 6.8846H13.5934Z'
            fill='#1434CB'
        />
    </SvgElement>
);
